<template>
    <b-overlay :show="loading">
        <iq-card>
            <template v-slot:body>
                <b-row>
                    <b-col md="12">
                     <h4>{{ $t('application_management.complain_recommendation') }}</h4>
                        <hr>
                        <p class="font-weight-bold text-dark">
                         {{$t('globalTrans.date')}}: {{items.created_at | dateFormat}}
                        </p>
                        <p class="font-weight-bold text-dark">
                            {{items.complain}}
                        </p>
                        <hr>
                    </b-col>
                    <b-col>
                        <div v-if="items.remarks">
                            <p class="text-dark">
                                {{items.remarks}}
                            </p>
                        </div>
                        <div class="text-center">
                            <b-badge v-if="items.status === 2" class="p-2" pill variant="success"> <h4 class="text-light">{{ $t('application_management.resolved')}}</h4></b-badge>
                            <b-badge v-else class="p-2" pill variant="warning"> <h4 class="text-dark">{{ $t('globalTrans.pending')}}</h4></b-badge>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
    </b-overlay>
</template>
<script>
    import { core } from '@/config/pluginInit'
    import RestApi, { trainingElearningServiceBaseUrl } from '../../../../../../config/api_config'
    import { ComplainSolveApi } from '../../api/routes'

export default {
    props: ['items'],
    components: {
    },
      created () {
        if (this.items.id) {
            this.formData.id = this.items.id
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            loading: false,
            circularPublicationList: [],
            trainingNameList: [],
            formData: {
                remarks: null,
                id: null
            }
        }
    },
    computed: {
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
    },
    methods: {
        async saveData () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }

            result = await RestApi.postData(trainingElearningServiceBaseUrl, ComplainSolveApi, this.formData)

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.loading = false
                this.$bvModal.hide('modal-4')
            } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        Gender (type) {
            if (type === 1) {
                return this.$t('externalUser.male')
            } else if (type === 2) {
                return this.$t('externalUser.female')
            } else {
                return this.$t('externalUser.other')
            }
        },
        orgType (id) {
            const item = this.$store.state.TrainingElearning.commonObj.organizationTypeList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        org (id) {
            const item = this.$store.state.TrainingElearning.commonObj.regOrganizationList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        designation (id) {
            const item = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === id)
            if (this.$i18n.locale === 'bn') {
                return item.text_bn
            } else {
                return item.text_en
            }
        },
        gender (id) {
            const list = [
                { value: 1, text: this.$i18n.locale === 'en' ? 'Male' : 'পুরুষ' },
                { value: 2, text: this.$i18n.locale === 'en' ? 'Female' : 'মহিলা' },
                { value: 3, text: this.$i18n.locale === 'en' ? 'Other' : 'অন্যান্য' }
            ]
            return list.find(item => item.value === id).text
        }
    }
}

</script>
